<template>
  <div class="confirmation-message" v-if="emailConfirmed">
    Email confirmado com sucesso!
  </div>

  <div class="confirmation-message" v-else>
    O email já foi confirmado ou este link não é mais válido
  </div>
</template>
<script>
import { confirmEmail } from "../../services/registrations";
import { logOut } from "../../services/sessions";

export default {
  data() {
    return {
      emailConfirmed: false,
    };
  },

  methods: {
    logoutUser() {
      logOut()
        .then(() => {
          this.$store.commit("userStatus", {
            loggedInfo: "NOT_LOGGED_IN",
            userData: {},
          });
        })
        .catch((error) => {
          console.log("logoutUser error", error);
        });
    },
  },

  created() {
    this.logoutUser();
    confirmEmail(this.$route.params.token)
      .then((response) => {
        if (response.status == 200) {
          this.emailConfirmed = true;
        }
      })
      .catch((error) => {
        console.log("email confirmation error", error);
      });
  },
};
</script>

<style scoped>
.confirmation-message {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  background-color: #d3dce6;
  width: 40%;
  margin: auto;
  margin-top: 2%;
  margin-bottom: 2%;
  padding-top: 2%;
  padding-bottom: 2%;
  padding-left: 2%;
  padding-right: 2%;
  text-align: center;
  font-size: 25px;
}
</style>
